import {Typography} from '@mui/material';

type Props = {
    title: string | undefined;
};

export default function BlockTitle({title}: Props) {
    return (
        <>
            {title ? (
                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        mb: 1,
                    }}
                >
                    {title}
                </Typography>
            ) : null}
        </>
    );
}
